import React from "react";
import Agent from "./agent.jsx";
import { formatDateAsYMD } from "../utils/dateUtils.jsx";

export const getbarbers = async (barber) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  return await requests.getAtt(
    `/barber/GetAllPublicStaff?BarbershopId=${barber}`,
    null
  );
};

export const getAvailableTimeSlots = async (
  barberId,
  shopId,
  date,
  requiredMinutes
) => {
  try {
    const token = localStorage.getItem("authToken");
    const { requests } = Agent();

    return await requests.get(
      `/Barber/AvailableTimeSlot?barber=${barberId}&shop=${shopId}&date=${formatDateAsYMD(
        date
      )}&requiredMinutes=${requiredMinutes}`,
      null,
      null
    );
  } catch (error) {
    console.error(
      "Error updating barber availability:",
      error.response?.data || error.message
    );
    throw error;
  }
};
